import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'

import api from '@/lib/api'

interface UpdateParams {
  id: string
  valor: number
}

export function useUpdateResumes() {
  const queryClient = useQueryClient()
  const user = useCurrentUser()
  const token = useAccessToken()

  return useMutation({
    mutationFn: async ({ id, valor }: UpdateParams) => {
      if (!user || !token) throw new Error('Usuário não autenticado')

      const body = {
        id,
        value: valor
      }

      const response = await api.patch(`/resume/update/value`, body, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (response.data) {
        return response.data
      } else {
        throw new Error('Erro ao atualizar valor do total')
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['productSenha'] })
    }
  })
}
